module.exports = __webpack_public_path__ + "img/vmware.7c66b38a.svg";